import { httpservice } from '../services';
import { constants } from '../constant/constant';

let apiEndPoint;

export const getNotificationList = () => {
  const query = `${constants.API.NOTIFICATIONS}`;
  return httpservice()
    .get(query)
    .then((response) => {
      const notificationData = response.data.response;
      return { data: notificationData, count: notificationData.length };
    })
    .catch((error) => error);
};

export const getNotificationCount = () => {
  const query = `${constants.API.NOTIFICATIONS}/count`;
  return httpservice()
    .get(query)
    .then((response) => {
      const notificationCount = response.data.response;
      return { status: 200, count: notificationCount.count };
    })
    .catch((error) => error);
};

export const doDeleteNotification = (id) => httpservice()
  .delete(`${constants.API.NOTIFICATIONS}/${id}`)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));

export const doUpdateNotification = (id) => httpservice()
  .put(`${constants.API.NOTIFICATIONS}/${id}`)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));

export const doUpdateNotificationSettings = (formData) => {
  apiEndPoint = constants.ADMIN_URL + constants.API.NOTIFICATION_SETTINGS;

  return httpservice()
    .post(`${apiEndPoint}`, formData)
    .then((response) => response.data)
    .catch((error) => (error.response && error.response.data ? error.response.data : error));
};
